<template>
  <div :key="'reset-hist-index-' + loadIndex" :class="{'reset-hist': true, 'shown': shown}">
    <div class="ing-contents">
      <div class="today-me" v-html="$t('reset.text.today_me')" />
      <div class="goal-area">
        <div class="goal-body-weight">
          <div class="goal-body-weight-title">
            <div class="dot" />
            <div class="label font-extra-bold">
              {{ $t('reset_manager.label.weight') }}
            </div>
            <div class="dot" />
          </div>
          <div class="text font-extra-bold">
            <input
              v-model="resetHist.bdwgh"
              type="number"
              class="goal-input"
              :placeholder="$t('reset.placeholder.goal_weight')"
              :tabindex="1"
              @focus="onFocusNumberInput($event)"
              @blur="onBlurNumberInput($event)"
              @keypress="onKeypressOnInput($event)"
            >
            <div class="goal-text">
              {{ resetHist.bdwgh }}kg
            </div>
          </div>
        </div>

        <div class="goal-body-fat">
          <div class="goal-body-fat-title">
            <div class="dot" />
            <div class="label font-extra-bold">
              {{ $t('reset_manager.label.fat') }}
            </div>
            <div class="dot" />
          </div>
          <div class="text font-extra-bold">
            <input
              v-model="resetHist.bodyFatRate"
              type="number"
              class="goal-input"
              :placeholder="$t('reset.placeholder.goal_body_fat')"
              :tabindex="2"
              @focus="onFocusNumberInput($event)"
              @blur="onBlurNumberInput($event)"
              @keypress="onKeypressOnInput($event)"
            >
            <div class="goal-text">
              {{ resetHist.bodyFatRate }}%
            </div>
          </div>
        </div>
      </div>
      <div class="this-hist-date">
        <span v-if="reset && getPreviousDate() >= reset.bgnde" @click="gotoDate(getPreviousDate())"><i class="fa fa-chevron-left" /></span>
        <span v-else><i class="fa fa-chevron-left white" /></span>
        {{ getHistDate() }}
        <span v-if="reset && getNextDate() <= reset.endde" @click="gotoDate(getNextDate())"><i class="fa fa-chevron-right" /></span>
        <span v-else><i class="fa fa-chevron-right white" /></span>
      </div>
      <div class="history-contents">
        <div class="schedule-time-tabs">
          <div :class="{'morning': true, 'active': scheduleTimeTab === 'morning'}" @click="setScheduleTimeTab('morning', $event)">
            <img src="/img/reset/ic_morning.png" :alt="$t('reset.text.morning')" class="time-icon">
            {{ $t('reset.text.morning') }}
          </div>
          <div :class="{'noon': true, 'active': scheduleTimeTab === 'noon'}" @click="setScheduleTimeTab('noon', $event)">
            <img src="/img/reset/ic_noon.png" :alt="$t('reset.text.noon')" class="time-icon">
            {{ $t('reset.text.noon') }}
          </div>
          <div :class="{'night': true, 'active': scheduleTimeTab === 'night'}" @click="setScheduleTimeTab('night', $event)">
            <img src="/img/reset/ic_night.png" :alt="$t('reset.text.night')" class="time-icon">
            {{ $t('reset.text.night') }}
          </div>
        </div>
        <!-- div class="schedule-detail-wrapper hidden">
          <div v-if="selectedSchedule[scheduleTimeTab] && selectedSchedule[scheduleTimeTab].length > 0" class="schedule-detail-container">
            <div v-for="(schedDetail, schedDetailIndex) in selectedSchedule[scheduleTimeTab]" :key="'sched-detail-' + schedDetail.id + '-' + schedDetailIndex" class="schedule-detail">
              <div class="dot" />
              <div class="image">
                <centered-image :cover="true" :src="getImgUrl(schedDetail.product.image[0])" :alt="schedDetail.product.nm" />
              </div>
              <div class="name">
                {{ schedDetail.product.nm }}
              </div>
              <div class="quantity">
                {{ schedDetail.intakeCo }}{{ schedDetail.product.unit }}
              </div>
            </div>
          </div>
          <div v-else class="no-intake-data">
            {{ $t('common.text.no_intake') }}
          </div>
        </div -->
        <div class="image-title">
          {{ $t('reset.text.' + scheduleTimeTab) }}{{ $t('reset.text.image') }}
          <button class="btn image-title-button" :disabled="disabled" @click="clickUpload($event)">
            {{ $t('reset.button.upload') }}
          </button>
        </div>
        <div v-if="scheduleTimeTab === 'morning'" class="image-uploaders one-image-uploaders">
          <div class="image-uploader morning-front-image">
            <input-control
              key="morning-front-image"
              v-model="resetHist.morningFrontImages"
              camera-button-image="/themes/default/pack/img/Android/drawable-mdpi/btn_mypage_profile_photo.png"
              type="singlefile"
              :no-title="true"
              title=" "
              table-name="reset_hist"
              :file-info="{purpose: 'file_purpose.morning_front',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
              :disabled="disabled"
            />
          </div>
        </div>
        <div v-else-if="scheduleTimeTab === 'noon'" class="image-uploaders one-image-uploaders">
          <div class="image-uploader noon-front-image">
            <input-control
              key="noon-front-image"
              v-model="resetHist.noonFrontImages"
              camera-button-image="/themes/default/pack/img/Android/drawable-mdpi/btn_mypage_profile_photo.png"
              type="singlefile"
              :no-title="true"
              title=" "
              table-name="reset_hist"
              :file-info="{purpose: 'file_purpose.noon_front',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
              :disabled="disabled"
            />
          </div>
        </div>
        <div v-else-if="scheduleTimeTab === 'night'" class="image-uploaders one-image-uploaders">
          <div class="image-uploader night-front-image">
            <input-control
              key="night-front-image"
              v-model="resetHist.nightFrontImages"
              camera-button-image="/themes/default/pack/img/Android/drawable-mdpi/btn_mypage_profile_photo.png"
              type="singlefile"
              :no-title="true"
              title=" "
              table-name="reset_hist"
              :file-info="{purpose: 'file_purpose.night_front',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
              :disabled="disabled"
            />
          </div>
        </div>
        <div class="clear" />
      </div>
      <div class="clear" />
    </div>
    <div v-if="isEndDay && isResultUpdatable" class="result-contents">
      <div v-if="stipulation" class="stipulation-checkbox-area">
        <button class="btn btn-detail-show" :disabled="isCouponUser()" @click="showStipulation($event)">
          {{ $t('reset.button.show_detail') }}
        </button>
        <input-control
          v-model="reset.shareFlag"
          name="share_flag"
          type="checkbox"
          :is-switch="false"
          :disabled="isCouponUser()"
          :title="stipulation.title"
        />
        <b-modal
          id="stipulation-modal"
          ref="stipulationModalRef"
          modal-class="simple-design"
          :title="stipulation.title"
          :ok-title="$t('common.button.ok')"
          :ok-only="true"
          :lazy="false"
          :centered="true"
          :no-close-on-backdrop="true"
        >
          <p class="my-4 stipulation-contents" v-html="stipulation.cn" />
          <input-control
            v-model="reset.shareFlag"
            name="share_flag"
            type="checkbox"
            :is-switch="false"
            :disabled="isCouponUser()"
            :title="$t('stipulation.button.agree')"
          />
        </b-modal>
      </div>
      <div class="success-story">
        <div class="congratulation">
          {{ $t('reset.text.success') }}
        </div>
        <div class="success-story-title">
          {{ $t('reset.text.your_reset_story') }}
        </div>
        <div class="success-story-contents">
          <input-control
            v-model="reset.story"
            :disabled="!isResultUpdatable"
            name="story"
            type="textarea"
            :no-title="true"
            :placeholder="isResultUpdatable ? $t('reset.placeholder.insert_reset_story') : ''"
            :title="$t('column.nm.story')"
            :auto-resize="true"
          />
        </div>
      </div>
      <div class="basis-info basis-info-2">
        <div class="basis-info-title">
          <img class="reset-editor-icon person" src="/img/icons/ico_info_g.png" alt="Info">
          &nbsp;
          {{ $t('reset.text.final_result') }}
        </div>
        <div class="basis-info-2-container">
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.bdwgh') }}<span class="unit">(kg)</span>
              </div>
            </div>
            <div class="clear" />
            <div class="basis-info-begin">
              <div class="begin-number basis-info-number simple-design">
                <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
                {{ reset.bgnBdwgh }}
              </div>
            </div>
            <div class="basis-info-result">
              <input-control
                v-model="reset.resultBdwgh"
                type="number"
                :disabled="!isResultUpdatable"
                class="result-number basis-info-number simple-design"
                :title="$t('reset.editor.result')"
                placeholder=" "
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.bone_rate') }}<span class="unit">(kg)</span>
              </div>
            </div>
            <div class="basis-info-begin">
              <div class="begin-number basis-info-number simple-design">
                <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
                {{ reset.bgnBoneRate }}
              </div>
            </div>
            <div class="basis-info-result">
              <input-control
                v-model="reset.resultBoneRate"
                type="number"
                :disabled="!isResultUpdatable"
                class="result-number basis-info-number simple-design"
                :title="$t('reset.editor.result')"
                placeholder=" "
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.body_fat') }}<span class="unit">(kg)</span>
              </div>
            </div>
            <div class="basis-info-begin">
              <div class="begin-number basis-info-number simple-design">
                <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
                {{ reset.bgnBodyFat }}
              </div>
            </div>
            <div class="basis-info-result">
              <input-control
                v-model="reset.resultBodyFat"
                type="number"
                :disabled="!isResultUpdatable"
                class="result-number basis-info-number simple-design"
                :title="$t('reset.editor.result')"
                placeholder=" "
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.bmi') }}<span class="unit">(kg/m<sup>2</sup>)</span>
              </div>
            </div>
            <div class="clear" />
            <div class="basis-info-begin">
              <div class="begin-number basis-info-number simple-design">
                <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
                {{ reset.bgnBmi }}
              </div>
            </div>
            <div class="basis-info-result">
              <input-control
                v-model="reset.resultBmi"
                type="number"
                :disabled="!isResultUpdatable"
                class="result-number basis-info-number simple-design"
                :title="$t('reset.editor.result')"
                placeholder=" "
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
              />
            </div>
          </div>
          <div class="basis-info-row">
            <div class="basis-info-label-container">
              <div class="dot" />
              <div class="basis-info-label">
                {{ $t('column.nm.body_fat_rate') }}<span class="unit">(%)</span>
              </div>
            </div>
            <div class="clear" />
            <div class="basis-info-begin">
              <div class="begin-number basis-info-number simple-design">
                <label class="basis-info-number-label">{{ $t('reset.editor.begin') }}</label>
                {{ reset.bgnBodyFatRate }}
              </div>
            </div>
            <div class="basis-info-result">
              <input-control
                v-model="reset.resultBodyFatRate"
                type="number"
                :disabled="!isResultUpdatable"
                class="result-number basis-info-number simple-design"
                :title="$t('reset.editor.result')"
                placeholder=" "
                @focus="onFocusNumberInput($event)"
                @blur="onBlurNumberInput($event)"
              />
            </div>
          </div>
        </div>
        <div class="basis-info-row inbody-image-row">
          <div class="basis-info-label-container">
            <div class="basis-info-title">
              <img class="reset-editor-icon inbody" src="/img/icons/ic_inbody.png" alt="Info">
              &nbsp;
              {{ $t('reset.editor.inbody_image') }}
            </div>
          </div>
          <div class="basis-info-controls basis-info-images-controls inbody-image-control">
            <div class="basis-info-control">
              <input-control
                id="inbody-image-file"
                v-model="reset.resultInbodyImages"
                type="singlefile"
                :show-image-view="true"
                custom-click-event="show-inbody-image"
                :no-title="true"
                :no-control-area="true"
                title=" "
                table-name="reset"
                :file-info="{purpose: 'file_purpose.result_inbody',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
                @custom-click-event="onCustomClickEvent"
                @changed="onInbodyImageChanged"
              />
              <div v-if="inbodyImage && showInbodyImage" class="inbody-image" @click="toggleInbodyImage">
                <centered-image :src="getImgUrl(inbodyImage)" />
              </div>
            </div>
            <div class="btn-inbody-upload" @click="uploadInbodyImage($event)">
              +
            </div>
          </div>
        </div>
        <div :class="{'inbody-result-row': true, 'has-contents': ocrResult}" v-html="ocrResult" />
        <div class="result-image-row">
          <div class="result-image-title">
            <div class="dot" />
            <div class="basis-info-label">
              {{ $t('reset.editor.result_photo') }}
              <span class="show-sample" @click="toggleSampleImage($event)">
                {{ $t('reset.editor.sample_image') }}
              </span>
              <div v-if="showSample" class="sample-image" @click="toggleSampleImage($event)">
                <img src="/img/reset/sample.png" alt="Sample">
              </div>
            </div>
          </div>
          <div class="basis-info-controls basis-info-images-controls result-images-controls">
            <div id="result-front-image-area" class="basis-info-control">
              <input-control
                v-model="reset.resultFrontImages"
                type="singlefile"
                :no-title="true"
                title=" "
                table-name="reset"
                :file-info="{purpose: 'file_purpose.result_front',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
                :tabindex="18"
                @keypress="onKeypressOnInput($event)"
              />
              <div class="basis-info-control-name-and-button">
                <div class="basis-info-control-name">
                  {{ $t('reset.editor.front_image') }}
                </div>
                <div class="upload-btn" @click="uploadImageClick('#result-front-image-area', $event)">
                  {{ $t('button.text.upload') }}
                </div>
              </div>
            </div>
            <div id="result-side-image-area" class="basis-info-control">
              <input-control
                v-model="reset.resultSideImages"
                type="singlefile"
                :no-title="true"
                title=" "
                table-name="reset"
                :file-info="{purpose: 'file_purpose.result_side',accept: '.jpg,.jpeg,.gif,.bmp,.png', defaultImage: 'unistars/top_logo_white.png'}"
                :tabindex="19"
                @keypress="onKeypressOnInput($event)"
              />
              <div class="basis-info-control-name-and-button">
                <div class="basis-info-control-name">
                  {{ $t('reset.editor.side_image') }}
                </div>
                <div class="upload-btn" @click="uploadImageClick('#result-side-image-area', $event)">
                  {{ $t('button.text.upload') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="controls detail-schedule-controls bottom-fixed-controls">
      <div class="button-area">
        <button class="btn no-border" @click="saveConfirm($event)">
          {{ $t('common.button.save') }}
        </button>
      </div>
      <div class="button-area">
        <button class="btn no-border" @click="toList($event)">
          {{ $t('reset.button.list') }}
        </button>
      </div>
    </div>
    <b-modal
      id="save-confirm-modal"
      ref="saveConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      centered
      :no-close-on-backdrop="true"
      @ok="save($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.save_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    initReset: {
      type: Object,
      default: undefined
    },
    day: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadIndex: 0,
      showSample: false,
      resetHist: {
        bdwgh: '0',
        bodyFatRate: '0',
        morningFrontImages: [],
        morningSideImages: [],
        noonFrontImages: [],
        noonSideImages: [],
        nightFrontImages: [],
        nightSideImages: []
      },
      isEndDay: false,
      scheduleTimeTab: 'morning',
      selectedSchedule: {},
      disabled: false,
      shown: false,
      stipulation: undefined,
      ocrResult: '',
      reset: undefined,
      isResultUpdatable: true,
      inbodyImage: undefined,
      showInbodyImage: false
    }
  },
  watch: {
    '$route.query.yyyymmdd': {
      handler(newVal, oldVal) {
        this.isEndDay = false
        if (this.reset && this.reset.endde === newVal) {
          this.isEndDay = true
        }
        this.loadHist()
      },
      deep: true
    }
  },
  async mounted() {
    if (this.initReset) {
      this.reset = this.initReset
    } else if (this.$route.query.resetId) {
      const response = await this.$axios.$get(
        '/reset/reset?id=' + this.$route.query.resetId
      )
      if (response && response.resultCode === 'success') {
        this.reset = response.data
      }
    }
    if (!this.reset) {
      this.$toast.error('존재하지 않는 리셋이거나 잘못된 접근입니다.')
      history.go(-1)
    }
    this.loadHist()
  },
  beforeDestroy() {
    delete this.$route.query.resetId
  },
  methods: {
    uploadImageClick(selector, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      $(selector + ' input[type=file]')
        .get(0)
        .click(e)
    },
    toggleSampleImage(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showSample = !this.showSample
      this.$forceUpdate()
    },
    onCustomClickEvent(e) {
      this.inbodyImage = e.file
      this.showInbodyImage = !this.showInbodyImage
      this.$forceUpdate()
    },
    toggleInbodyImage(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showInbodyImage = !this.showInbodyImage
      this.$forceUpdate()
    },
    gotoDate(de) {
      const query = {}
      for (const key in this.$route.query) {
        query[key] = this.$route.query[key]
      }
      query.yyyymmdd = de
      this.$router.push({
        query: query
      })
      this.$forceUpdate()
    },
    getPreviousDate() {
      if (!this.$route.query.yyyymmdd) {
        return
      }
      const strs = this.$route.query.yyyymmdd.split('/')
      const de = new Date(strs[0], strs[1] - 1, strs[2])
      de.setDate(de.getDate() - 1)
      return this.$options.filters.formatDate(de.getTime())
    },
    getNextDate() {
      if (!this.$route.query.yyyymmdd) {
        return
      }
      const strs = this.$route.query.yyyymmdd.split('/')
      const de = new Date(strs[0], strs[1] - 1, strs[2])
      de.setDate(de.getDate() + 1)
      return this.$options.filters.formatDate(de.getTime())
    },
    async loadHist() {
      const query = {}
      for (const key in this.$route.query) {
        query[key] = this.$route.query[key]
      }
      if (this.reset) {
        query.resetId = this.reset.id
        this.$router.replace({
          query: query
        })
        this.$forceUpdate()
      }
      let yyyymmdd
      if (this.$route.query.yyyymmdd) {
        yyyymmdd = this.$route.query.yyyymmdd
      } else {
        yyyymmdd = this.day.year + '/'
        if (this.day.month + 1 < 10) {
          yyyymmdd += '0'
        }
        yyyymmdd = yyyymmdd + (this.day.month + 1)
        yyyymmdd += '/'
        if (this.day.day < 10) {
          yyyymmdd += '0'
        }
        yyyymmdd += this.day.day
        if (!this.$route.query.yyyymmdd) {
          query.yyyymmdd = yyyymmdd
          this.$router.replace({
            query: query
          })
        }
      }
      const response = await this.$axios.$get(
        '/reset/hist?resetId=' +
          this.reset.id +
          '&de=' +
          encodeURIComponent(yyyymmdd)
      )
      if (response && response.data) {
        this.resetHist = response.data
      } else {
        this.resetHist = {}
        if (this.isCouponUser()) {
          this.reset.shareFlag = 'N'
        } else {
          this.reset.shareFlag = 'Y'
        }
      }
      if (this.reset.endde === yyyymmdd) {
        this.isEndDay = true
      }
      const today = new Date()
      let todayYyyymmdd = today.getFullYear() + '/'
      if (today.getMonth() + 1 < 10) {
        todayYyyymmdd = todayYyyymmdd + '0'
      }
      todayYyyymmdd = todayYyyymmdd + (today.getMonth() + 1) + '/'
      if (today.getDate() < 10) {
        todayYyyymmdd = todayYyyymmdd + '0'
      }
      todayYyyymmdd = todayYyyymmdd + today.getDate()
      /*
      if (yyyymmdd !== todayYyyymmdd) {
        this.disabled = true
      }
       */
      const yesterday1 = new Date()
      yesterday1.setDate(yesterday1.getDate() - 1)
      let yesterdayYyyymmdd1 = yesterday1.getFullYear() + '/'
      if (yesterday1.getMonth() + 1 < 10) {
        yesterdayYyyymmdd1 = yesterdayYyyymmdd1 + '0'
      }
      yesterdayYyyymmdd1 =
        yesterdayYyyymmdd1 + (yesterday1.getMonth() + 1) + '/'
      if (yesterday1.getDate() < 10) {
        yesterdayYyyymmdd1 = yesterdayYyyymmdd1 + '0'
      }
      yesterdayYyyymmdd1 = yesterdayYyyymmdd1 + yesterday1.getDate()

      const yesterday2 = new Date()
      yesterday2.setDate(yesterday2.getDate() - 2)
      let yesterdayYyyymmdd2 = yesterday2.getFullYear() + '/'
      if (yesterday2.getMonth() + 1 < 10) {
        yesterdayYyyymmdd2 = yesterdayYyyymmdd2 + '0'
      }
      yesterdayYyyymmdd2 =
        yesterdayYyyymmdd2 + (yesterday2.getMonth() + 1) + '/'
      if (yesterday2.getDate() < 10) {
        yesterdayYyyymmdd2 = yesterdayYyyymmdd2 + '0'
      }
      yesterdayYyyymmdd2 = yesterdayYyyymmdd2 + yesterday2.getDate()

      const yesterday3 = new Date()
      yesterday3.setDate(yesterday3.getDate() - 3)
      let yesterdayYyyymmdd3 = yesterday3.getFullYear() + '/'
      if (yesterday3.getMonth() + 1 < 10) {
        yesterdayYyyymmdd3 = yesterdayYyyymmdd3 + '0'
      }
      yesterdayYyyymmdd3 =
        yesterdayYyyymmdd3 + (yesterday3.getMonth() + 1) + '/'
      if (yesterday3.getDate() < 10) {
        yesterdayYyyymmdd3 = yesterdayYyyymmdd3 + '0'
      }
      yesterdayYyyymmdd3 = yesterdayYyyymmdd3 + yesterday3.getDate()

      if (
        yyyymmdd === todayYyyymmdd ||
        yyyymmdd === yesterdayYyyymmdd1 ||
        yyyymmdd === yesterdayYyyymmdd2 ||
        yyyymmdd === yesterdayYyyymmdd3
      ) {
        this.isResultUpdatable = true
      }
      this.resetHist.de = yyyymmdd
      this.resetHist.resetId = this.reset.id
      if (this.reset.schedules) {
        for (let i = 0; i < this.reset.schedules.length; i++) {
          const sched = this.reset.schedules[i]
          if (yyyymmdd === sched.de) {
            this.selectedSchedule = sched
            break
          }
        }
      }
      if (this.isEndDay) {
        const response = await this.$axios.$get(
          '/stipulation/public/stipulation?stplatTyCode=stipulation_type.reset&stplatPrposCode=stipulation_purpose.share'
        )
        if (response.data && response.data.length > 0) {
          this.stipulation = response.data[0]
        }
      }
      this.$nextTick(() => {
        this.shown = true
        this.loadIndex++
        this.$forceUpdate()
      })
    },
    onInbodyImageChanged(e) {
      let file
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        file = e.target.files[0]
      }
      this.recognize(file, numbers => {
        if (numbers && numbers.length > 0) {
          for (let i = numbers.length - 1; i >= 0; i--) {
            if (isNaN(numbers[i])) {
              numbers.splice(i, 1)
            }
          }
          if (numbers.length > 0) {
            this.reset.resultBdwgh = parseFloat(numbers[0])
          }
          if (numbers.length > 1) {
            this.reset.resultBoneRate = parseFloat(numbers[1])
          }
          if (numbers.length > 2) {
            this.reset.resultBodyFat = parseFloat(numbers[2])
          }
          if (numbers.length > 3) {
            this.reset.resultBmi = parseFloat(numbers[3])
          }
          if (numbers.length > 4) {
            this.reset.resultBodyFatRate = parseFloat(numbers[4])
          }
          this.$forceUpdate()
        }
      })
    },
    uploadInbodyImage(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      $('#inbody-image-file input[type=file]')
        .get(0)
        .click(e)
    },
    saveConfirm(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('saveConfirmModalRef')
    },
    save(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)

      if (!this.isEndDay) {
        this.$axios.$put('/reset/hist', this.resetHist).then(response => {
          if (response.resultCode === 'success') {
            this.hideModal('saveConfirmModalRef')
            this.$toast.info(this.$t(response.message))
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
      } else {
        if (this.reset.shareFlag === 'Y') {
          this.reset.stplatId = this.stipulation.id
        }
        this.reset.lastResetHist = this.resetHist
        this.$axios.$post('/reset/saveFinal', this.reset).then(response => {
          if (response.resultCode === 'success') {
            this.reset = response.data
            this.hideModal('saveConfirmModalRef')
            if (this.reset.lastResetHist) {
              this.resetHist = this.reset.lastResetHist
            }
            this.$toast.info(this.$t(response.message))
          } else {
            console.error(this.$t(response.message))
            this.$toast.error(this.$t(response.message))
          }
        })
      }
    },
    showStipulation(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('stipulationModalRef')
    },
    clickUpload(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      const control = '.' + this.scheduleTimeTab + '-front-image'
      $(control + ' input[type=file]').click()
    },
    toList(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.$emit('to-list')
    },
    getHistDate() {
      if (!this.resetHist || !this.resetHist.de) {
        return
      }
      const strs = this.resetHist.de.split('/')
      if (!strs || strs.length !== 3) {
        return
      }
      const dt = new Date(strs[0], strs[1] - 1, strs[2])
      return (
        strs[1] +
        '/' +
        strs[2] +
        '(' +
        this.$t('common.text.day_short_' + dt.getDay()) +
        ')'
      )
    },
    setScheduleTimeTab(tab, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      if (this.scheduleTimeTab === tab) {
        return
      }
      this.vibrate(e)
      this.scheduleTimeTab = tab
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.reset-hist {
  background: white;
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
  padding-bottom: 5rem;
}
.reset-hist.shown {
  opacity: 1;
}
.controls {
  position: fixed;
  left: 0;
  bottom: 4rem;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100vw;
  justify-content: center;
  padding: 1.3166rem 1.5rem;
  background: white;
}
.controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.558rem;
  padding: 0.1rem 0 0;
  font-size: 0.95rem;
  height: 2.358rem;
  margin: 0 0.5rem;
  width: 6.73rem;
}
.goal-area {
  display: flex;
  padding: 0.5rem 0;
  justify-content: center;
  align-items: center;
  margin: 0;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.goal-body-fat,
.goal-body-weight {
  width: 50%;
  font-size: 0.833333rem;
  position: relative;
  padding: 0.8rem 0 0.3rem;
}
.goal-body-fat-title,
.goal-body-weight-title {
  display: flex;
  align-items: center;
  justify-content: center;
}
.goal-area .text {
  font-size: 1.86rem;
  text-align: center;
  padding-top: 0.3rem;
  font-weight: bold;
}
.goal-area .goal-body-fat-title .dot,
.goal-area .goal-body-weight-title .dot {
  width: 0.56rem;
  height: 0.56rem;
  border-radius: 0.28rem;
}
.goal-area .goal-body-weight-title .dot {
  background-color: #360ea6;
}
.goal-area .goal-body-fat-title .dot {
  background-color: #03ccc8;
}
.goal-area .goal-body-weight-title .label {
  color: #360ea6;
}
.goal-area .goal-body-fat-title .label {
  color: #03ccc8;
}
.goal-area .label {
  font-weight: normal;
  letter-spacing: 0.04rem;
  font-size: 0.8833rem;
}
.goal-area .goal-body-weight-title > div,
.goal-area .goal-body-fat-title > div {
  float: left;
}
.schedule-time-tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 0.5rem;
}
.schedule-time-tabs div {
  font-size: 0.883333rem;
  font-weight: bold;
  padding: 0.7rem 1rem 0.5rem;
  opacity: 0.5;
  border-bottom: 1px solid white;
}
.schedule-time-tabs div.active {
  border-bottom: 1px solid #360ea6;
  opacity: 1;
}
img.time-icon {
  height: 0.98333333rem;
}
.history-contents {
  margin: 0 1.5rem 2rem;
  background: white;
  border-radius: 1rem;
  padding: 0 0 2.5rem;
  position: relative;
}
.goal-text {
  margin: 0 calc(50% - 3.575rem);
  width: 7.15rem;
  border: 1px solid #bebebe;
  background: white;
  height: 2.9rem;
}
.goal-input {
  left: 0;
  top: 2.43rem;
  margin: 0 calc(50% - 3.575rem);
  width: 7.15rem;
  border: 1px solid #bebebe;
  text-align: center;
  opacity: 0;
  position: absolute;
  height: 2.9rem;
}
.goal-input:active,
.goal-input:focus {
  opacity: 1;
  outline: none !important;
}
.schedule-detail-wrapper {
  position: relative;
}
.schedule-detail-container {
  max-height: 18.3333rem;
  overflow-x: hidden;
  overflow-y: auto;
}
.schedule-detail {
  text-align: center;
  padding: 0.5rem;
  font-size: 0.9083rem;
  display: flex;
  align-items: center;
  height: 3.6666rem;
  background: #e8ecf4;
  border-bottom: 1px solid #d1d6dd;
}

.schedule-detail .dot {
  width: 0.1916rem;
  height: 0.1916rem;
  background: #b2b2b2;
  border-radius: 0.1rem;
  margin-left: 0.5rem;
}
.schedule-detail .image {
  width: 2.875rem;
  height: 2.4166rem;
  margin-left: 0.7rem;
  overflow: hidden;
}
.schedule-detail .name {
  margin-left: 0.5rem;
  width: calc(100% - 10.2666rem);
  text-align: left;
}
.schedule-detail .quantity {
  width: 4rem;
  text-align: right;
  padding-right: 1rem;
  margin-left: 0.5rem;
}
.image-title {
  font-size: 0.83rem;
  margin: 0 0.5rem 2rem;
  padding: 0.9rem 0.5rem;
  height: 3rem;
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
}
.image-title-button:hover,
.image-title-button:active,
.image-title-button:focus {
  color: white;
}
.image-title-button {
  float: right;
  margin-top: -0.2rem;
  font-size: 0.6666rem;
  color: white;
  background: #360ea6;
  border-radius: 0.3rem;
  padding: 0.5rem 1.7rem;
  height: 1.48rem;
  line-height: 0.3rem;
}
.image-uploaders {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 0.5rem;
}
.image-uploaders .image-uploader,
.image-uploaders .image-uploader >>> .dropping-line,
.image-uploaders .image-uploader >>> .file-preview-slide,
.image-uploaders .image-uploader >>> .file-control {
  height: 34vw;
  width: 34vw;
}
.one-image-uploaders.image-uploaders .image-uploader,
.one-image-uploaders.image-uploaders .image-uploader >>> .dropping-line,
.one-image-uploaders.image-uploaders .image-uploader >>> .file-preview-slide,
.one-image-uploaders.image-uploaders .image-uploader >>> .file-control {
  height: 68vw;
  width: 68vw;
}
.image-uploaders .image-uploader >>> .file-preview-slide {
  background-size: 2.5rem auto;
  background-color: #e7edf5;
  border: none !important;
  border-radius: 0.5rem;
  background-position: 50% 30vw;
}
.image-uploaders .image-uploader >>> .multifile-uploader.form-control {
  border: none !important;
}
.image-uploaders .image-uploader >>> .upload-guide {
  display: none;
}
.stipulation-checkbox-area label {
  font-size: 1rem;
  font-weight: normal;
  color: black;
}
.stipulation-checkbox-area {
  background: white;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  padding: 1.4rem 1rem 1rem;
  position: relative;
}
.basis-info-control-name {
  font-size: 0.8rem;
}
.stipulation-checkbox-area .input-control {
  min-height: auto;
  margin-bottom: 0 !important;
  font-weight: lighter;
}
.btn-detail-show:hover,
.btn-detail-show:focus,
.btn-detail-show:active {
  outline: none !important;
  color: #360ea6 !important;
  box-shadow: none !important;
  border: none !important;
}
.btn-detail-show {
  font-size: 0.916666666666667rem;
  color: white;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #360ea6;
  line-height: 0;
  height: 1.666666666666667rem;
  width: 4.775rem;
  z-index: 2;
  position: absolute;
  right: 1rem;
  top: 1.4rem;
  border-radius: 0.6rem;
}
.stipulation-contents {
  border: rgba(55, 55, 55, 0.2) 1px solid;
  max-height: 50vh;
  overflow-y: auto;
  word-break: keep-all;
}
.success-story {
  margin: 0;
  background-image: url('/img/unistars/header_background.png');
  background-repeat: no-repeat;
  background-size: 120vw;
  background-position: -5vw -10vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  border-radius: 0;
  padding: 1.5rem 0 1rem;
}
.success-story .congratulation {
  color: #00fffa;
  font-size: 1.6666rem;
}
.success-story-title {
  color: white;
  font-size: 1.3666rem;
  margin: 0.2rem 0;
}
.success-story .input-control {
  min-height: auto;
  margin-bottom: 0 !important;
  padding: 0.5rem 0;
}
.success-story >>> textarea {
  line-height: 1.4rem !important;
  max-height: 7rem;
}
.success-story >>> input,
.success-story >>> textarea {
  background: transparent;
  font-size: 1.3666rem !important;
  z-index: 1;
  min-height: auto;
  line-height: 1rem;
  color: white;
  text-align: center;
  border: none !important;
  box-shadow: none !important;
  padding: 0;
  height: auto;
}
.success-story >>> textarea:active,
.success-story >>> textarea:focus,
.success-story >>> textarea:hover,
.success-story >>> input:active,
.success-story >>> input:focus,
.success-story >>> input:hover {
  outline: none !important;
}
.success-story >>> textarea::placeholder,
.success-story >>> input::placeholder {
  font-size: 1rem !important;
  line-height: 1rem;
  color: rgba(255, 255, 255, 0.7);
}
.success-story-contents {
  width: 19rem;
}
.reset-editor-icon {
  width: 0.9166rem;
}
.basis-info-title {
  padding-left: 1rem;
  color: #747474;
  font-size: 0.791666666666667rem !important;
  height: 3.275rem;
  display: flex;
  align-items: center;
  background: rgba(244, 244, 244, 0.4);
}
.basis-info-row {
  display: flex;
  align-items: center;
  clear: both;
  font-size: 1rem;
  min-height: 3.275rem;
  padding: 0.6rem 0;
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
}
.inbody-image-row.basis-info-row {
  border-bottom: none;
}
.inbody-result-row {
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
  font-size: 0.8833rem;
  text-align: center;
}
.inbody-result-row.has-contents {
  padding-bottom: 1rem;
}
.basis-info-row .dot {
  width: 0.1916rem;
  height: 0.1916rem;
  background: #b2b2b2;
  border-radius: 0.1rem;
  margin: 0 0.5rem;
}
.basis-info-label {
  font-weight: bold;
  display: flex;
  align-items: center;
  width: calc(100% - 1.5rem);
  font-size: 0.833333333333333rem;
}
.number-label {
  font-size: 0.75rem;
  color: #707070;
}
.basis-info-number {
  float: right;
  margin-left: 0.2rem;
}
.input-control.simple-design.basis-info-number {
  border: 1px solid #f4f4f4;
  border-radius: 0.766666666666667rem;
  height: 1.858333333333333rem;
  width: 100%;
}
.basis-info-goal .input-control.simple-design.basis-info-number >>> label {
  background: #0a2e65;
}
.input-control.simple-design.basis-info-number >>> .input-group,
.input-control.simple-design.basis-info-number >>> label {
  float: left;
  display: flex;
  align-items: center;
  height: 1.858333333333333rem;
  justify-content: center;
}
.input-control.simple-design.basis-info-number
  >>> .input-group
  input.form-control {
  background: transparent !important;
}
.input-control.simple-design.basis-info-number >>> label {
  font-size: 0.825rem;
  width: 3.691666666666667rem;
  background: #360ea6;
  color: white;
  border-radius: 0.766666666666667rem;
  margin-bottom: 0;
  margin: -1px;
}
.input-control.simple-design.basis-info-number >>> .input-group {
  width: calc(100% - 3.691666666666667rem);
}
.basis-info-number >>> input.form-control {
  border: none;
  height: 1.4rem !important;
  padding: 0.1rem 0 0 !important;
  margin-bottom: 0.1rem !important;
}
.simple-design.basis-info-number {
  border: 1px solid #f4f4f4;
  border-radius: 0.766666666666667rem;
  height: 1.858333333333333rem;
  width: 100%;
}
.basis-info-result .simple-design.basis-info-number >>> label {
  background: #0a2e65;
}
.basis-info-goal .simple-design.basis-info-number >>> label {
  background: #0a2e65;
}
.simple-design.basis-info-number >>> .input-group,
.simple-design.basis-info-number >>> label {
  float: left;
  display: flex;
  align-items: center;
  height: 1.858333333333333rem;
  justify-content: center;
}
.simple-design.basis-info-number >>> label {
  font-size: 0.825rem;
  width: 3.691666666666667rem;
  background: #360ea6;
  color: white;
  border-radius: 0.766666666666667rem;
  margin-bottom: 0;
  margin: -1px;
}
.basis-info-number,
.basis-info-number >>> input {
  width: 3.65rem;
  height: auto;
  line-height: 1.5rem;
  border: none;
  font-size: 0.95rem;
  text-align: center;
}
.basis-info-number.result-number >>> input {
  background: rgba(178, 178, 178, 0.1) !important;
  color: #01bfb2 !important;
}
.basis-info-begin,
.basis-info-goal,
.basis-info-result,
.basis-info-diff {
  width: 7.083333333333333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.675rem;
}
.basis-info-result {
  margin-bottom: 0.675rem;
}

.basis-info-controls {
  text-align: right;
}
.basis-info-controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.275rem;
  font-size: 0.95rem;
  width: 5.5rem;
  height: 2.483333rem;
  line-height: 0.1rem;
}
.basis-info-images-controls {
  display: flex;
  align-items: center;
  justify-content: end;
}
.basis-info-images-controls >>> .file-control,
.basis-info-images-controls >>> .file-preview-slide {
  height: 7.358333333333333rem;
  width: 7.358333333333333rem;
}
.basis-info-images-controls .basis-info-control {
  margin-left: 0.908rem;
  text-align: center;
  position: relative;
}
.basis-info-control >>> .upload-guide {
  display: none;
}
.basis-info-control >>> .input-control {
  overflow: hidden;
  margin-bottom: 0;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.basis-info-control >>> .no-selected-file {
  background-size: 1.833333333333333rem 2.066666666666667rem;
  background-color: #e7edf5;
  border: none !important;
  border-radius: 0.5rem;
  background-position: 50%;
}
.basis-info-control >>> .form-control {
  border: none;
}
.basis-info {
  background: white;
  border-radius: 0.5rem;
  padding: 0;
  margin-bottom: 1rem;
}
>>> .input-group .form-control {
  z-index: 1;
}
.today-me {
  color: #360ea6;
  font-size: 1.7083rem;
  background: white;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.5rem 0 0.5rem;
  text-align: center;
}
.this-hist-date {
  background: white;
  padding: 0.5rem 0;
  text-align: center;
  margin-bottom: 0.8rem;
}
.fa.white {
  color: white;
}
.this-hist-date .fa {
  padding: 0 1rem;
}
.no-intake-data {
  text-align: center;
  padding: 3rem 0;
}
.basis-info-row.header-row {
  margin-top: -2rem;
}
.basis-info-row.header-row .basis-info-label {
  width: calc(100% - 11rem);
}
.inbody-image {
  width: 80vw;
  position: absolute;
  left: -80vw;
  z-index: 12;
  bottom: 0;
}
.inbody-image >>> img {
  width: 100%;
  border: 1px solid #cccccc;
}
.sample-image {
  position: fixed;
  z-index: 1099;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.begin-image-title,
.result-image-title,
.intake-certificate-image-title {
  display: flex;
  border-bottom: 1px solid rgba(153, 153, 153, 0.4);
  height: 1.541666666666667rem;
  align-items: center;
  padding-bottom: 0.541666666666667rem;
  margin-bottom: 1rem;
}
.begin-image-title .basis-info-label,
.result-image-title .basis-info-label,
.intake-certificate-image-title .basis-info-label {
  width: calc(100% - 1.5rem);
  display: block;
}
.basis-info-2 {
  margin-bottom: 8rem;
}
.basis-info-2-container {
  display: flex;
  overflow: auto;
  width: 100vw;
  padding-bottom: 1rem;
}
.basis-info-2-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.basis-info-2-container .basis-info-row {
  width: calc(100vw / 3 - 1.1rem);
  min-width: calc(100vw / 3 - 1.1rem);
  margin-left: 0.65rem;
  margin-top: 0.775rem;
  display: flex;
  padding: 0 0.5rem;
  flex-direction: column;
  border: 1px solid #f4f4f4;
  border-radius: 0.208333333333333rem;
}
.basis-info-label-container {
  display: flex;
  align-items: center;
  height: 2.166666666666667rem;
  border-bottom: 1px solid #f4f4f4;
  width: 100%;
}
.inbody-image-row.basis-info-row {
  border-bottom: none;
  padding: 0;
}
.inbody-image-row {
  background: rgba(244, 244, 244, 0.4);
  height: 2.233333333333333rem;
  margin: 0 0.625rem 1rem;
}
.inbody-image-row .basis-info-title {
  background: transparent;
}
.inbody-result-row {
  border-bottom: rgba(0, 0, 0, 0.1) 1px solid;
  font-size: 0.8833rem;
  text-align: center;
}
.inbody-result-row.has-contents {
  padding-bottom: 1rem;
}
.inbody-image-row {
  height: 2.166666666666667rem;
  min-height: unset;
}
.inbody-image-control {
  height: 2.166666666666667rem;
}
.inbody-image-control.basis-info-images-controls >>> .file-control,
.inbody-image-control.basis-info-images-controls >>> .file-preview-slide {
  height: 1.5rem;
  width: 1.5rem;
}
.inbody-image {
  width: 80vw;
  position: absolute;
  left: -80vw;
  z-index: 12;
  bottom: 0;
}
.inbody-image >>> img {
  width: 100%;
  border: 1px solid #cccccc;
}
.basis-info-controls .btn-inbody-upload {
  background: transparent;
  color: #360ea6;
  font-weight: bolder;
  font-size: 1.8rem;
  padding: 0 1rem;
}
.result-image-row {
  border: 1px solid rgba(153, 153, 153, 0.4);
  border-radius: 0.5rem;
  margin: 0.65rem;
  padding: 1rem;
}
.basis-info-row .dot,
.result-image-title .dot {
  width: 0.5rem;
  height: 0.5rem;
  background: #360ea6;
  opacity: 0.2;
  border-radius: 50%;
  margin: 0 0.5rem;
}
.result-image-title .basis-info-label {
  width: calc(100% - 1.5rem);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.result-image-title {
  display: flex;
  border-bottom: 1px solid rgba(153, 153, 153, 0.4);
  height: 1.541666666666667rem;
  align-items: center;
  padding-bottom: 0.541666666666667rem;
  margin-bottom: 1rem;
}
.result-images-controls .basis-info-control {
  width: 50%;
  display: flex;
  margin-left: 0;
}
.basis-info-control-name-and-button .upload-btn {
  background: #d8d8d8;
  border-radius: 0.566666666666667rem;
  color: white;
  font-size: 0.716666666666667rem;
  width: 3.233333333333333rem;
  height: 1.608333333333333rem;
  margin-top: 0.608333333333333rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.result-image-title .basis-info-label .show-sample {
  float: right;
}
.show-sample {
  width: 3.4rem;
  height: 1.541666666666667rem;
  border-radius: 0.566666666666667rem;
  background: #d8d8d8;
  color: white;
  font-size: 0.691666666666667rem;
  text-align: center;
  margin-left: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.basis-info-control-name-and-button {
  padding: 0 0.816666666666667rem;
}
</style>
